var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BListFilter',{attrs:{"label":"Поиск по названию и описанию","skeleton":_vm.skeleton,"dense":""},on:{"change":_vm.onChangeDebounced},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }